import React                        from 'react';
import classnames                   from 'classnames';
import { minTraceSpace }            from 'pu-data/SelectOptions';
import { minTraceSpace as tooltip } from 'pu-data/Tooltips';
import SelectComponent              from './SelectComponent';

const Pitch = (props) => {
  const name = 'min_trace_space';
  const {parameters} = props;
  const onChange = e => props.onChangeParameter(name, e.target.value);
  const value = parameters[name];
  return (
    <SelectComponent
      label={props.label}
      required={props.required}
      name={name}
      onChange={onChange}
      options={props.options}
      tooltip={props.tooltip}
      selected={value}
      groupName={props.groupName}
      className={classnames('min-trace-space', props.className)} />
  );
};

Pitch.defaultProps = {
  options: minTraceSpace,
  tooltip,
  label  : 'Min. Trace<br class="d-none d-lg-block" /> Space',
};

export default Pitch;
